<div class="sm-flex sm-flex-col sm-space-y-4">
  <div class="sm-flex sm-items-center sm-justify-between">
    <span class="sm-flex">
      <h5 class="header-title sm-text-xl sm-font-medium sm-leading-5" i18n>{{ title }}</h5>
      <small data-test="user-count" class="text-muted fadeIn sm-self-center sm-pl-1" *ngIf="userCount"
        >({{ userCount }})</small
      >
    </span>
    <div class="text-center" *ngIf="learnMoreLink">
      <a
        [href]="learnMoreLink"
        target="_blank"
        class="px-2 py-1 rounded btn btn-sm cc-btn-subtle-gray help-text"
      >
        <i class="mr-1 cc-icon cc-icon-question"></i><span i18n>Learn more</span>
      </a>
    </div>
  </div>
  <ng-content></ng-content>
  <span class="header-subtitle" i18n>{{ title }} {{ subtitle }}</span>
</div>
